import { createAction, props } from '@ngrx/store';
import { Board, BoardHeader, Tag } from '../../entities/board.entity';

export const setDraftBoards = createAction(
  '[Session] Set Draft Boards',
  props<{ draftBoards: BoardHeader[] }>()
);

export const getDraftBoards = createAction('[Session] Get Draft Boards');


export const loadDraftBoards = createAction('[Session] Load Draft Boards');


export const loadDraftBoardsSuccess = createAction(
  '[Session] Load Draft Boards Success',
  props<{ draftBoards: BoardHeader[] }>()
);

export const loadDraftBoardsFailure = createAction(
  '[Session] Load Draft Boards Failure',
  props<{ error: any }>()
);

export const setSelectedBoard = createAction(
  '[Session] Set Selected Board',
  props<{ selectedBoard: Board | undefined }>()
);

export const clearSelectedBoard = createAction(
  '[Session] Clear Selected Board'
);


export const setTags = createAction(
  '[Session] Set Tags',
  props<{ tags: Tag[] }>()
);

export const addTags = createAction(
  '[Session] Add Tags',
  props<{ tags: Tag[] }>()
);

export const deleteTag = createAction(
  '[Session] Delete Tags',
  props<Tag>()
);
